import styled from 'react-emotion';

export const Diagram = styled.div`
	margin-bottom: 2.5rem;
`;

export const Line = styled.div`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	font-size: 0.875rem;
	margin-bottom: 1.25rem;
`;

export const Name = styled.div`
	flex: 1 0 100%;
	margin-bottom: 0.3rem;
	padding-right: 100px;
	box-sizing: border-box;

	@media (max-width: 480px) {
		padding-right: 75px;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const Bar = styled.div`
	background: #f2f2f2;
	flex: 1 0 1px;
	height: 1rem;
	position: relative;
`;

export const Progress = styled.div`
	background: #888;
	bottom: 0;
	left: 0;
	position: absolute;
	top: 0;
	width: 0;
`;

export const Value = styled.div`
	flex: 0 0 100px;
	line-height: 1;
	font-weight: 300;
	text-align: right;

	@media (max-width: 480px) {
		flex-basis: 75px;
	}
`;
